<template>
    <div class="w-full" style="max-width: 700px;">
        <h3 class="text-xl font-medium mt-4">
            {{ content[lang].rules[0].title }}
        </h3>

        <p class="xl:text-lg lg:text-md md:text-normal line-height-2">
            
        </p>

        <ul class="list-disc pl-4 gap-2">
            <li v-for="item in content[lang].rules[0].text" :key="item" class="mb-2 xl:text-lg lg:text-md md:text-normal line-height-2">
                {{ item }}
            </li>
        </ul>

        <h3 class="text-xl font-medium mt-4">
            {{ content[lang].rules[1].title }}
        </h3>

        <ul class="list-disc pl-4 gap-2">
            <li v-for="item in content[lang].rules[1].text" :key="item" class="mb-2 xl:text-lg lg:text-md md:text-normal line-height-2">
                {{ item }}
            </li>
        </ul>

        <h3 class="text-xl font-medium mt-4">
            {{ content[lang].rules[2].title }}
        </h3>

        <ul class="list-disc pl-4 gap-2">
            <li v-for="item in content[lang].rules[2].text" :key="item" class="mb-2 xl:text-lg lg:text-md md:text-normal line-height-2">
                {{ item }}
            </li>
        </ul>

        <h3 class="text-xl font-medium mt-4">
            {{ content[lang].rules[3].title }}
        </h3>

        <ul class="list-disc pl-4 gap-2">
            <li v-for="item in content[lang].rules[3].text" :key="item" class="mb-2 xl:text-lg lg:text-md md:text-normal line-height-2">
                {{ item }}
            </li>
        </ul>

        <h3 class="text-xl font-medium mt-4">
            {{ content[lang].rules[4].title }}
        </h3>

        <ul class="list-disc pl-4 gap-2">
            <li v-for="item in content[lang].rules[4].text" :key="item" class="mb-2 xl:text-lg lg:text-md md:text-normal line-height-2">
                {{ item }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'VCardRules',
    data() {
        return {
            header: {
                en: { title: 'Rules for using virtual cards' },
                ru: { title: 'Правила использования виртуальных карт' }
            },
            content: {
                ru: {
                    rules: [
                        {
                            title: 'Общие положения',
                            text: [
                                'Настоящие правила регулируют порядок предоставления услуги выпуска и пополнения виртуальных карт на нашем сайте.',
                                'Мы не являемся банком или финансовой организацией, выпускающей виртуальные карты. Карты выпускаются сторонними поставщиками, и мы не несем ответственности за их работу, условия использования и возможные ограничения.',
                                'Виртуальные карты — это удобный инструмент для онлайн-расчётов и оплаты через Apple Pay и другие платежные сервисы. Чтобы всё работало корректно, просим соблюдать базовые правила. При нарушении условий использования карта может быть заблокирована без возможности восстановления средств. Мы рассчитываем на вашу осознанность и соблюдение правил.',
                            ]
                        },
                        {
                            title: 'Ответственность',
                            text: [
                                'Мы гарантируем только выполнение операции пополнения виртуальных карт в пределах доступных средств и условий поставщика карт.',
                                'Мы не несем ответственности за блокировку, отказ в обслуживании, списания, лимиты и другие ограничения, установленные эмитентом карты.',
                                'Пользователь самостоятельно принимает на себя все риски, связанные с использованием карт, в том числе возможные ограничения или изменения условий со стороны поставщика.'
                            ]
                        },
                        {
                            title: 'Выпуск карты',
                            text: [
                                'В PayWave доступны два типа виртуальных карт: Карта для Apple Pay — работает и для онлайн-платежей, и для добавления в Apple Wallet. А так же карта для онлайн-оплат — подходит для оплаты в интернете, но не поддерживает Apple Pay.',
                                'Подробную информацию о тарифах на каждый тип карт можно найти в разделе "Карты" на нашем сайте.',
                            ]
                        },
                        {
                            title: 'Пополнение карт',
                            text: [
                                'Пополнение карт осуществляется только через пополнение с внутреннего кошелька PayWave, а именно Карточного счета пользователя.',
                                'Пополнение кошелька PayWave осуществляется двумя способами: через пополнение криптовалютой USDT в сети BEP20 или через пополнение с помощью перевода с карты на карту.',
                                'Баланс вашего кошелька PayWave и баланс самой виртуальной карты — это разные балансы. Для пополнения карты сначала нужно зачислить средства на карточный счёт в вашем кошельке',
                                'Время зачисления средств зависит от поставщика карт и может варьироваться, но как правило это занимает несколько секунд.',
                                'В случае технических сбоев или иных форс-мажорных обстоятельств возможны задержки в зачислении средств. Мы предпримем все возможные меры для скорейшего выполнения операции.'
                            ]
                        },
                        {
                            title: 'Ограничения и запреты',
                            text: [
                                'Платежи не поддерживаются в следующих юрисдикциях: Афганистан, Беларусь, Куба, Иран, Северная Корея, Сирия, Венесуэла, Россия, Мьянма, Сомали, Украина, Йемен.',
                                'Чтобы добавить карту в Apple Wallet, убедитесь, что в настройках Apple ID установлена страна, где доступен Apple Pay (например Казахстан).',
                                'Запрещается использовать виртуальные карты в незаконных целях.',
                                'Мы оставляем за собой право отказать в пополнении карт без объяснения причин, если подозреваем нарушение законодательства или наших правил.',
                                'Возврат средств возможен только в случаях, предусмотренных правилами поставщика карт.',
                            ]
                        },
                        {
                            title: 'Изменение условий',
                            text: [
                                'Мы вправе вносить изменения в настоящие правила без предварительного уведомления пользователей.',
                                'Актуальная версия правил всегда доступна на нашем сайте.'
                            ]
                        },
                    ],
                },
                en: {
                    rules: [
                        {
                            title: 'General Provisions',
                            text: [
                                'These rules govern the procedure for providing the service of issuing and topping up virtual cards on our website.',
                                'We are not a bank or financial institution issuing virtual cards. Cards are issued by third-party providers, and we are not responsible for their operation, terms of use, and possible restrictions.',
                                'Virtual cards are a convenient tool for online payments and Apple Pay transactions. To ensure everything works correctly, please follow basic rules. In case of violation of the terms of use, the card may be blocked without the possibility of restoring funds. We rely on your awareness and adherence to the rules.',
                            ]
                        },
                        {
                            title: 'Liability',
                            text: [
                                'We guarantee only the execution of the top-up operation for virtual cards within the available funds and conditions set by the card provider.',
                                'We are not responsible for blocking, refusal to service, charges, limits, and other restrictions imposed by the card issuer.',
                                'The user independently assumes all risks associated with the use of cards, including possible restrictions or changes in conditions by the provider.'
                            ]
                        },
                        {
                            title: 'Card Issuance',
                            text: [
                                'PayWave offers two types of virtual cards: Apple Pay Card — works for both online payments and adding to Apple Wallet. And Online Payment Card — suitable for internet payments but does not support Apple Pay.',
                                'Detailed information about tariffs for each type of card can be found in the "Cards" section on our website.',
                            ]
                        },
                        {
                            title: 'Card Top-Up',
                            text: [
                                'Card top-up is only available through internal PayWave wallet top-up, specifically through the User\'s Card Account.',
                                'PayWave wallet top-up can be done in two ways: through USDT cryptocurrency top-up in BEP20 network or through card-to-card transfer.',
                                'The balance of your PayWave wallet and the balance of the virtual card itself are different balances. To top up the card, you must first credit funds to your card account in your wallet.',
                                'The time for crediting funds depends on the card provider and may vary, but usually takes a few seconds.',
                                'In case of technical failures or other force majeure circumstances, there may be delays in crediting funds. We will take all possible measures to complete the operation as soon as possible.'
                            ]
                        },
                        {
                            title: 'Restrictions and Prohibitions',
                            text: [
                                'Payments are not supported in the following jurisdictions: Afghanistan, Belarus, Cuba, Iran, North Korea, Syria, Venezuela, Russia, Myanmar, Somalia, Ukraine, Yemen.',
                                'To add a card to Apple Wallet, make sure that the country set in your Apple ID settings supports Apple Pay (for example, Kazakhstan).',
                                'Using virtual cards for illegal purposes is prohibited.',
                                'We reserve the right to refuse to top up cards without explanation if we suspect a violation of legislation or our rules.',
                                'Refunds are possible only in cases provided for by the card provider\'s rules.',
                            ]
                        },
                        {
                            title: 'Changes to Terms',
                            text: [
                                'We reserve the right to make changes to these rules without prior notice to users.',
                                'The current version of the rules is always available on our website.'
                            ]
                        },
                    ],
                }
            }
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
};
</script>